let createCookiePermission = false
function defineLanguage(language){
    // if(createCookiePermission)
    document.cookie = `lang=${language};`
}

    

export default defineLanguage;